import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Container, Row, Col } from "react-bootstrap";
import BgImg from "../../images/services-usa/game_update/bg_black.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

function TechnologyUse(props) {
  return (
    <section
      className="technologyuse game-technologyuse p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={7} lg={7} className="m-auto text-center">
            <h2>Technologies We Use</h2>
            <p>
              Our mobile game app developers utilize the latest technologies to
              create a robust game.
            </p>
          </Col>
        </Row>
        <Row className="technologyuse_main">
          <Col xs={12} md={12} lg={12}>
            <div className="tech_icons">
              <Swiper
                loop={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                spaceBetween={0}
                modules={[Autoplay]}
                breakpoints={{
                  320: {
                    slidesPerView: 2,
                  },
                  768: {
                    slidesPerView: 4,
                  },
                  1024: {
                    slidesPerView: 5,
                  },
                  1366: {
                    slidesPerView: 7,
                  },
                  1600: {
                    slidesPerView: 7,
                  },
                }}
                className="web_case_slider"
              >
                <SwiperSlide>
                  <div className="tech_img">
                    <StaticImage
                      src="../../images/services-usa/game_update/tech_use/icon_15.webp"
                      alt="tekrevol_game_development"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={79}
                      height={80}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="tech_img">
                    <StaticImage
                      src="../../images/services-usa/game_update/tech_use/icon_01.webp"
                      alt="tekrevol_game_development"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={208}
                      height={80}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="tech_img">
                    <StaticImage
                      src="../../images/services-usa/game_update/tech_use/icon_10.webp"
                      alt="tekrevol_game_development"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={63}
                      height={80}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="tech_img">
                    <StaticImage
                      src="../../images/services-usa/game_update/tech_use/icon_02.webp"
                      alt="tekrevol_game_development"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={81}
                      height={80}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="tech_img">
                    <StaticImage
                      src="../../images/services-usa/game_update/tech_use/icon_06.webp"
                      alt="tekrevol_game_development"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={95}
                      height={85}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="tech_img">
                    <StaticImage
                      src="../../images/services-usa/game_update/tech_use/icon_05.webp"
                      alt="tekrevol_game_development"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={81}
                      height={80}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="tech_img">
                    <StaticImage
                      src="../../images/services-usa/game_update/tech_use/icon_14.webp"
                      alt="tekrevol_game_development"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={217}
                      height={80}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="tech_img">
                    <StaticImage
                      src="../../images/services-usa/game_update/tech_use/icon_11.webp"
                      alt="tekrevol_game_development"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={80}
                      height={80}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="tech_img">
                    <StaticImage
                      src="../../images/services-usa/game_update/tech_use/icon_13.webp"
                      alt="tekrevol_game_development"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={81}
                      height={80}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="tech_img">
                    <StaticImage
                      src="../../images/services-usa/game_update/tech_use/icon_03.webp"
                      alt="tekrevol_game_development"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={144}
                      height={80}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="tech_img">
                    <StaticImage
                      src="../../images/services-usa/game_update/tech_use/icon_08.webp"
                      alt="tekrevol_game_development"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={73}
                      height={80}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="tech_img">
                    <StaticImage
                      src="../../images/services-usa/game_update/tech_use/icon_07.webp"
                      alt="tekrevol_game_development"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={109}
                      height={80}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="tech_img">
                    <StaticImage
                      src="../../images/services-usa/game_update/tech_use/icon_09.webp"
                      alt="tekrevol_game_development"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={62}
                      height={80}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="tech_img">
                    <StaticImage
                      src="../../images/services-usa/game_update/tech_use/icon_16.webp"
                      alt="tekrevol_game_development"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={101}
                      height={80}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="tech_img">
                    <StaticImage
                      src="../../images/services-usa/game_update/tech_use/icon_12.webp"
                      alt="tekrevol_game_development"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={81}
                      height={80}
                    />
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default TechnologyUse;
